import { createAsyncThunk } from "@reduxjs/toolkit";
import { ApiResponse, OrganizationContactResponse } from "../../types/certWatch";
import api from "../api/api";
import { RootState } from "../store";

export const getCCOsNeedAttentionByOrgId = createAsyncThunk<
  ApiResponse<OrganizationContactResponse>,
  {
    organizationId: string;
    page: number;
    pageNumber: number;
    pageSize: number;
    sortBy: string;
    sortOrder: "asc" | "desc",
    searchTerm?: string;
    statusFilter?: number | null;
    FirstNameSearch?: string;
    LastNameSearch?: string;
    CcoIdSearchTermTab2?: string;
  },
  { rejectValue: string }
>(
  "ccoAdvanceTab2/getCCOsNeedAttentionByOrgId",
  async ({
    organizationId,
    searchTerm,
    page,
    pageNumber,
    pageSize,
    sortBy,
    sortOrder,
    statusFilter,
    FirstNameSearch,
    LastNameSearch,
    CcoIdSearchTermTab2
  }, { rejectWithValue, getState }) => {
    try {
      const state = (getState() as RootState).ccoAdvanceTab2;

      const requestBody: any = {
        OrganizationId: organizationId,
        PageNumber: pageNumber || page,
        PageSize: pageSize,
        SortBy: sortBy ?? "LastName",
        SortOrder: sortOrder ?? "asc",
      };

      // Add optional filters from passed parameters (not Redux state)
      if (statusFilter !== null && statusFilter !== undefined) {
        requestBody.StatusFilter = statusFilter;
      }

      if (searchTerm?.trim()) {
        requestBody.SearchTerm = searchTerm.trim();
      }

      if (FirstNameSearch?.trim()) {
        requestBody.FirstNameSearch = FirstNameSearch.trim();
      }

      if (LastNameSearch?.trim()) {
        requestBody.LastNameSearch = LastNameSearch.trim();
      }

      if (CcoIdSearchTermTab2?.trim()) {
        requestBody.CcoIdSearchTerm = CcoIdSearchTermTab2.trim();
      }



      const response = await api.post(
        "certWatch/getCCOsNeedAttentionByOrgId",
        requestBody,
        {
          headers: { "Content-Type": "application/json" },
        }
      );

      if (response.data?.Success && response.data.Data) {
        return {
          Data: {
            Items: response.data.Data?.Items ?? [],
            TotalCount: response.data.Data?.TotalCount ?? (response.data.Data?.Items?.length || 0),
            PageNumber: response.data.Data.PageNumber ?? state.Page,
            PageSize: response.data.Data.PageSize ?? state.PageSize,
            TotalPages:
              response.data.Data.TotalPages ??
              Math.ceil((response.data.Data.TotalCount ?? 0) / state.PageSize),
          },
          Success: response.data.Success,
          Message: response.data.Message,
          ApiCode: response.data.ApiCode,
        };
      }

      return rejectWithValue(response.data?.Message || "Failed to fetch CCOs needing attention");
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.Message || error.message);
    }
  }
);
